export default __webpack_public_path__ + "static/media/Manual-8.212b0475.png";